import styled from 'styled-components';

export const AvoidBreakInside = styled.div`
  height: 100%;

  @media print {
    break-inside: avoid;
  }
`;
